/* eslint-disable react/no-unescaped-entities */
import styles from '@buddieshr/styles/hr-policies.module.scss';
import MetaHeader from '@buddieshr/components/metaHeader';
import { useRouter } from 'next/router';
import Header from '@buddieshr/components/header';
import Footer from '@buddieshr/components/footer';
import PageWrapper from '@buddieshr/components/templates/pageWrapper';
import {
  FileDoneOutlined,
  // SearchOutlined
} from '@ant-design/icons';
import { getPolicies } from '@buddieshr/utils/api';
import {
  // Input,
  Table,
  Tag,
} from 'antd';
import Link from 'next/link';
import moment from 'moment';
// import { useState } from 'react';

export default function HRPolicies({ refSource, categoriesWithPolicies }) {
  const router = useRouter();
  //   const [search, setSearch] = useState(null);
  const categories = Object.keys(categoriesWithPolicies);
  return (
    <>
      <MetaHeader
        title={'300+ Essential HR Policies and Procedures, free examples'}
        description={
          'Access more than 300 HR policies for free listed per category from Flexible hours policies to Perks and Benefits policies or Hybrid workplace policies.'
        }
        currentURL={`https://buddieshr.com/${router.locale === 'en' ? '' : router.locale
          }/hr-policies`}
        locale={router.locale}
        pageSlug={'hr-policies'}
        isArticle
        currentShare={'https://buddieshr.com/img/hr-policies.png'}
      />
      <Header />
      <main className={styles.main}>
        <article>
          <PageWrapper width={800} style={{ paddingBottom: 24 }}>
            <header className={styles.header}>
              <div className={styles.headerInner}>
                <div>
                  <FileDoneOutlined className={styles.topicon} />
                </div>
                <h1 className={styles.title}>
                  HR Policies and Procedures: Key Examples
                </h1>
                <div className={styles.description}>
                  <p>
                    Clear HR policies are crucial for maintaining a fair,
                    compliant, and productive workplace. On this page, you’ll
                    find a variety of free HR policy examples covering key areas
                    like employee conduct, leave, performance management, and
                    more.
                  </p>

                  <br />
                  <p>
                    These templates are here to help you get started.{' '}
                    <b>
                      Simply download, customize, and adapt them to fit your
                      company’s needs.
                    </b>
                  </p>
                  <br />
                  <p>
                    We hope these resources support you in building a
                    well-organized and compliant workplace!
                  </p>
                </div>
              </div>
            </header>
          </PageWrapper>
          <div className={styles.categoryListingWrapper}>
            <PageWrapper style={{ padding: 0, paddingBottom: 22 }} width={800}>
              <p>
                <b>
                  Before listing the 300+ examples of policies across all
                  categories, here is the list of all the policy categories that
                  can help HRs face their everyday challenges. Categories are:
                </b>
              </p>
            </PageWrapper>
            <PageWrapper width={1000} style={{ paddingTop: 12 }}>
              <div style={{ paddingLeft: 34 }}>
                <ul className={styles.categoryListTop}>
                  {categories.map((c) => (
                    <li key={`${c}_list`}>
                      <Link href={`#${c}`} title={`${c} policies`}>
                        {c}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </PageWrapper>
          </div>

          <PageWrapper width={930}>
            {/* <div className={styles.filterText}>
              <label>Filter by Policy Name</label>
              <Input
                onChangeCapture={(e) => setSearch(e.target.value)}
                value={search}
                size="large"
                prefix={<SearchOutlined />}
              />
            </div> */}
            <div>
              {categories.map((category, i) => {
                const pols = categoriesWithPolicies[category];
                const dataSource = pols.map((p) => ({ ...p, key: p._id }));
                const columns = [
                  {
                    title: 'Policy Name',
                    dataIndex: 'policyName',
                    key: (e) => `${category}_${e.policyName}${e.policyId}`,
                    render: (text, el) => (
                      <h3 style={{ margin: 0 }}>
                        {el.policyTemplateLink.substring(0, 4) === 'http' ? (
                          <Link
                            href={el.policyTemplateLink}
                            target={'_blank'}
                            className={styles.policyName}
                            title={`${text} policy example`}
                          >{text}</Link>
                        ) : (
                          <span>{text}</span>
                        )}
                      </h3>
                    ),
                  },
                  {
                    title: 'Policy Industry',
                    dataIndex: 'tags',
                    key: (e) =>
                      `${category}_${e.industry.flat().toString()}${e.policyId
                      }`,
                    render: (text, element) =>
                      element.industry.map((indus) => (
                        <Tag key={`table_${indus}`} color="blue">
                          {indus}
                        </Tag>
                      )),
                  },
                  {
                    title: 'Company Source',
                    dataIndex: 'organisation',
                    key: (e) => `${category}_${e.organisation}_${e.policyId}`,
                    render: (text, element) =>
                      text.substring(0, 4) === 'http' ? (
                        <div>
                          <Link href={text} target="_blank">
                            {text}
                          </Link>
                          {` (${element.employees} employees, stage ${element.stage})`}
                        </div>
                      ) : (
                        <div>
                          <span> {text}</span>{' '}
                          {` (${element.employees} employees, stage ${element.stage})`}
                        </div>
                      ),
                  },
                  // {
                  //   title: 'Publish date',
                  //   dataIndex: 'createdAt',
                  //   key: 'createdAt',
                  //   render: (text) => moment(new Date(text)).format('DD MMM YYYY'),
                  // },
                ];
                return (
                  <div
                    key={category}
                    className={styles.categoryWrapper}
                    id={category}
                  >
                    <h2
                      className={styles.categoryTitle}
                    >{`${category} policies`}</h2>
                    <Table
                      pagination={false}
                      dataSource={dataSource}
                      columns={columns}
                    />
                  </div>
                );
              })}
            </div>
            <div>
              <h2 style={{ marginBottom: 12 }}>About</h2>
              <p>
                This page provides access to startup policies agregated and
                collected from publicly available sources for informational
                purpose only. The inclusion of any policy in this index does not
                imply endorsement or legal advice.
              </p>
            </div>
          </PageWrapper>
        </article>
      </main>
      <Footer refSource={refSource} />
    </>
  );
}

export async function getServerSideProps({ res }) {
  res.setHeader(
    'Cache-Control',
    'public, s-maxage=10, stale-while-revalidate=59'
  );
  const { policies } = await getPolicies();

  const categories = policies
    .reduce((acc, element) => {
      const filtered = element.policyType.filter((p) => !acc.includes(p));
      return [...acc, ...filtered];
    }, [])
    .sort((a, b) => {
      if (a < b) return -1;
      if (a > b) return 1;
      return 0;
    });

  const categoriesWithPolicies = categories.reduce(
    (acc, element) => ({
      ...acc,
      [element]: policies.filter((p) => p.policyType.includes(element)),
    }),
    {}
  );
  return { props: { categoriesWithPolicies } };
}
